import styled from "styled-components";
import { BlueBirdTheme, Table, TableRow } from "@kitbird/core";

const { primary } = BlueBirdTheme.colors;

export const StickyTable = styled.div`
  width: 100%;
  overflow: auto;
  height: 100%;
`;

export const CustomTableRow = styled(TableRow) <{ isEven?: boolean, $isSelected?: boolean }>`
  border-top: ${({ isEven }) => isEven && `1px solid ${primary[200]} `};
  border-bottom: ${({ isEven }) => isEven && `1px solid ${primary[200]} `};
  background-color: ${({ $isSelected }) => $isSelected && primary[200]} !important;
  cursor:  ${({ onClick }) => !!onClick && "pointer"};
`;

export const CustomTable = styled(Table) <{ $hoverable?: boolean }>`
  width: 100%;
  table-layout: fixed;
  td {
    border: none;
    padding: 16px 12px;
  }
  tr:nth-child(even) {
    border-top: 1px solid ${primary[200]};
    border-bottom: 1px solid ${primary[200]};
  }
  ${({ $hoverable }) => $hoverable && `tr:hover {
      background-color: ${primary[200]} !important;
  }`}
`;

export const TableMessage = styled.div`
  height: 100%;
  justify-content: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
